export const SURVEY_BUILDER_SET_LIST = 'SURVEY_BUILDER_SET_LIST';
export const SURVEY_BUILDER_SET_COUNT = 'SURVEY_BUILDER_SET_COUNT';
